import isEmpty from "@/libs/isEmpty";

function cleanData(data: { [index: string]: any }): any {
    return Object.keys(data)
        .filter(el => !isEmpty(data[el]))
        .reduce((obj: { [index: string]: any }, item: string) => {
            obj[item] = data[item];
            return obj;
        }, {});
}

export default cleanData;